(function() {
  // 1. Tilføj skjult knap hvis den ikke findes
  if (!document.getElementById('sjolin-konfigurator-btn-v2')) {
    const btn = document.createElement('button');
    btn.id = 'sjolin-konfigurator-btn-v2';
    btn.innerText = 'Se som kunde';
    btn.style.display = 'none';
    document.body.appendChild(btn);
  }

  // 2. Konfiguration til Sjölin
  window.SJOLIN_CONFIG_V2 = {
    buttonColor: '#000000',
    buttonTextColor: '#ffffff'
  };

  // 3. Event listeners for style-fjernelse + afslut-dialog
  (function() {
    function removeShopifyStyles() {
      console.log('%c 🔥 REMOVING SHOPIFY STYLES', 'background:red; color:white; font-weight:bold;');
      const count1 = document.querySelectorAll('style[data-shopify]').length;
      document.querySelectorAll('style[data-shopify]').forEach(el => el.remove());

      setTimeout(() => {
        const count2 = document.querySelectorAll('style[data-shopify]').length;
        console.log('%c 🕒 DELAYED REMOVAL (1s)', 'background:red; color:white;');

        document.querySelectorAll('style[data-shopify]').forEach(el => el.remove());
        document.querySelectorAll('style').forEach(el => {
          if (el.innerHTML.includes('shopify')) el.remove();
        });

        console.log(`Removed ${count1} initially, ${count2} after delay`);
      }, 1000);
    }

    document.addEventListener('click', function(e) {
      if (e.target.id === 'sjolin-konfigurator-btn-v2' || e.target.closest('#sjolin-konfigurator-btn-v2')) {
        removeShopifyStyles();
      }
    }, true);

    document.addEventListener('click', function(e) {
      if (e.target.className === 'sjolin-close-v2' || e.target.closest('.sjolin-close-v2')) {
        e.preventDefault();
        e.stopPropagation();

        const dialog = document.createElement('div');
        dialog.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.75); display:flex; align-items:center; justify-content:center; z-index:9999999;';
        dialog.innerHTML = `
          <div style="background:white; padding:30px; border-radius:8px; max-width:400px; text-align:center;">
            <h3 style="margin-top:0; font-size:20px; color:#333;">Afslut designer side</h3>
            <p style="margin-bottom:25px; color:#666;">Er du sikker på, at du vil afslutte design selv?</p>
            <div style="display:flex; justify-content:center; gap:15px;">
              <button id="sjolin-no" style="padding:10px 20px; border:1px solid #ddd; background:#f5f5f5; border-radius:4px; cursor:pointer;">Nej</button>
              <button id="sjolin-yes" style="padding:10px 20px; border:none; background:#10b981; color:white; border-radius:4px; cursor:pointer;">Ja</button>
            </div>
          </div>
        `;
        document.body.appendChild(dialog);

        document.getElementById('sjolin-no').onclick = function() {
          document.body.removeChild(dialog);
        };
        document.getElementById('sjolin-yes').onclick = function() {
          document.body.removeChild(dialog);
          window.location.reload(true);
        };
        return false;
      }
    }, true);

    console.log('Custom handlers installed successfully');
  })();

  // 4. Load embed script med cache-buster
  const embedScript = document.createElement('script');
  embedScript.src = 'https://sjolin.netlify.app/embed-v2.js?v=' + new Date().getTime();
  embedScript.async = true;
  document.head.appendChild(embedScript);

  // 5. Tilføj billede i mega-menu (desktop)
  const addImageToMegaMenu = () => {
    document.querySelectorAll('.theme-normal .mega-menu__content').forEach((menuContent) => {
      const megaList = menuContent.querySelector('.mega-menu__list');
      if (!megaList || megaList.querySelector('.mega-menu-image-col')) return;

      megaList.style.setProperty('display', 'grid', 'important');
      megaList.style.setProperty('gap', '2.4rem 4rem', 'important');
      megaList.style.setProperty('grid-template-columns', 'repeat(6, minmax(0, 1fr))', 'important');
      megaList.style.setProperty('list-style', 'none', 'important');

      const imageItem = document.createElement('li');
      imageItem.className = 'mega-menu-image-col';
      imageItem.style.marginTop = '0';
      imageItem.style.alignSelf = 'start';
      imageItem.style.cursor = 'pointer';

      const image = document.createElement('img');
      image.src = 'https://cdn.shopify.com/s/files/1/0607/9669/8791/files/Screenshot_138.png?v=1744466976';
      image.alt = 'Åbn Sjölin Konfigurator';
      image.style.width = '100%';
      image.style.borderRadius = '8px';
      image.style.boxShadow = '0 0 10px rgba(0,0,0,0.05)';
      image.style.display = 'block';

      imageItem.appendChild(image);

      imageItem.addEventListener('click', () => {
        const triggerBtn = document.getElementById('sjolin-konfigurator-btn-v2');
        if (triggerBtn) triggerBtn.click();
      });

      megaList.appendChild(imageItem);
    });
  };

  // 6. Tilføj billede i mobil-menu
  const addImageToMobileMenu = () => {
    const menuDrawer = document.querySelector('.theme-normal .menu-drawer__navigation .menu-drawer__menu');
    if (!menuDrawer || document.getElementById('mobile-sjolin-image')) return;

    const li = document.createElement('li');
    li.className = 'menu-drawer__menu-item list-menu__item';
    li.id = 'mobile-sjolin-image';
    li.style.cursor = 'pointer';
    li.style.marginTop = '1rem';
    li.style.padding = '1rem';

    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0607/9669/8791/files/Screenshot_138.png?v=1744466976';
    img.alt = 'Åbn Sjölin Konfigurator';
    img.style.width = '100%';
    img.style.borderRadius = '8px';
    img.style.boxShadow = '0 0 10px rgba(0,0,0,0.05)';
    img.style.display = 'block';

    li.appendChild(img);

    li.addEventListener('click', () => {
      const btn = document.getElementById('sjolin-konfigurator-btn-v2');
      if (btn) btn.click();
    });

    menuDrawer.appendChild(li);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      addImageToMegaMenu();
      addImageToMobileMenu();
    });
  } else {
    addImageToMegaMenu();
    addImageToMobileMenu();
  }
})();